import { AutogenLayoutOfficePayAdjustmentHistoryList } from "./autogen/AutogenLayoutOfficePayAdjustmentHistoryList";

export class OfficePayAdjustmentHistoryList extends AutogenLayoutOfficePayAdjustmentHistoryList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "check_date", sort: "desc" },
            { field: "payee_id", sort: "asc" },
            { field: "check_number", sort: "asc" }
        ];
    }
}
